import React, { useState } from 'react';
import { PlusIcon, EditIcon, TrashIcon, SearchIcon, ToggleLeftIcon, ToggleRightIcon } from 'lucide-react';
import { OutboundEmailConfig as OutboundEmailConfigType } from './EmailConfiguration';
interface OutboundEmailConfigProps {
  outboundConfigs: OutboundEmailConfigType[];
  setOutboundConfigs: React.Dispatch<React.SetStateAction<OutboundEmailConfigType[]>>;
  locale: string;
}
export function OutboundEmailConfig({
  outboundConfigs,
  setOutboundConfigs,
  locale
}: OutboundEmailConfigProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const filteredConfigs = outboundConfigs.filter(config => config.fromEmail.toLowerCase().includes(searchTerm.toLowerCase()) || config.fromName.toLowerCase().includes(searchTerm.toLowerCase()) || config.entityName && config.entityName.toLowerCase().includes(searchTerm.toLowerCase()) || config.siteName && config.siteName.toLowerCase().includes(searchTerm.toLowerCase()));
  const handleToggleActive = (id: string) => {
    setOutboundConfigs(outboundConfigs.map(config => config.id === id ? {
      ...config,
      isActive: !config.isActive
    } : config));
  };
  const handleToggleDefault = (id: string) => {
    setOutboundConfigs(outboundConfigs.map(config => config.id === id ? {
      ...config,
      isDefault: !config.isDefault
    } : {
      ...config,
      isDefault: false
    }));
  };
  return <div className="space-y-6" data-id="element-15290">
      <div className="bg-white shadow-sm rounded-lg p-4" data-id="element-15291">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center space-y-4 sm:space-y-0" data-id="element-15292">
          <div className="flex-1 max-w-md" data-id="element-15293">
            <div className="relative rounded-md shadow-sm" data-id="element-15294">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-15295">
                <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-15296" />
              </div>
              <input type="text" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md" placeholder="Search outbound configurations..." data-id="element-15297" />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-15298">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-15299">
          <thead className="bg-gray-50" data-id="element-15300">
            <tr data-id="element-15301">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-15302">
                From Email
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-15303">
                Scope
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-15304">
                Method
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-15305">
                Default
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-15306">
                Status
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-15307">
            {filteredConfigs.map(config => <tr key={config.id} className="hover:bg-gray-50" data-id="element-15308">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-15309">
                  <div className="text-sm font-medium text-gray-900" data-id="element-15310">
                    {config.fromEmail}
                  </div>
                  <div className="text-sm text-gray-500" data-id="element-15311">{config.fromName}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-15312">
                  {config.scopeLevel === 'Tenant' ? 'Tenant-wide' : config.scopeLevel === 'Entity' ? `Entity: ${config.entityName}` : `Site: ${config.siteName}`}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-15313">
                  <div data-id="element-15314">{config.sendingMethod}</div>
                  {config.sendingMethod === 'SMTP' && <div className="text-xs text-gray-400" data-id="element-15315">
                      {config.smtpHost}:{config.smtpPort}
                    </div>}
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-15316">
                  <button onClick={() => handleToggleDefault(config.id)} className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${config.isDefault ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-15317">
                    {config.isDefault ? 'Default' : 'Set as Default'}
                  </button>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-15318">
                  <button onClick={() => handleToggleActive(config.id)} className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${config.isActive ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-15319">
                    {config.isActive ? 'Active' : 'Inactive'}
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}